import "../../../../styles/css/table.scss";
import "../../../../App.css";
import { RouteComponentProps } from "react-router-dom";
import Helper from "../../../../Common/Helper";
import { appContext } from "../../../../AppContext";
import { rights } from "../../../../Common/RightsManager";
import IbssDataGrid from "../../../../Components/Data/DataGrid/IbssDataGrid";
import { GridColDef } from "@mui/x-data-grid";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import CreateIcon from '@mui/icons-material/Create';
import IbssActionButton, { IActionButton } from "../../../../Components/Buttons/ActionButton/IbssActionButton";
import AddIcon from "../../../../Components/Icons/AddIcon";
import { Box, Grid } from "@mui/material";
import IbssFilter from "../../../../Components/Forms/Filter/IbssFilter";
import IbssPageHeader from "../../../../Components/Headings/PageHeading/IbssPageHeader";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { IUserView, User } from "./DataModels";

class ListUsers extends IbssPage<IProps, IState>
{
  private get labels() { return appContext().labels; }
  private userCanUpdate: boolean;
  private userCanCreate: boolean;

  constructor(props: IProps)
  {
    super(props);
    this.userCanCreate = rights.ADMINPORTAL.Users.Create.has();
    this.userCanUpdate = rights.ADMINPORTAL.Users.Update.has();

    this.state =
    {
      isLoading: false,
      users: [],
      isCreateRight: false,
      isUpdateRight: false,
      filterText: "",
    }
  }


  public componentDidMount(): void
  {
    this.pageTitle = this.labels.HubMenuManage;
    this.loadUsers();
  }

  private async loadUsers(): Promise<void>
  {
    try
    {
      this.setState({
        isLoading: true,
      });
      const userResponse = await appContext().webEntryApiClientV1.api.webentry.v1.security.users.get<User[]>({})
      const userDetails = userResponse?.map((user:User) => 
      ({
        id: user.id,
        displayName: user.displayName?.trim() || user.email,
        identityProviderName: user.identityProviderName,
        securityProviderTypeName: user.securityProviderTypeName,
        userType: user.userType,
      }))

      this.setState({
        isLoading: false,
        users: userDetails
      });

    } 
    catch (error)
    {
      this.setState({
        isLoading: false,
      });
    }
  }


  private handleCreate(): void
  {
    const { history } = this.props;
    history.push("security-users/userdetails/0");
  }

  private handleUpdate(id: string): React.ReactNode 
  {
    return this.userCanUpdate ? (
      <IbssSvgIcon onClick={() => this.props.history.push(`security-users/userdetails/${id}`)}>
        <CreateIcon />
      </IbssSvgIcon>
    ) : (
      <p>-</p>
    );
  }


  private filterUsers(searchTerm: string): IUserView[]
  {
    if (!searchTerm || searchTerm.trim() === "")
    {
      return this.state.users;
    }

    const lowercaseSearchTerm = searchTerm.toLowerCase().trim();

    return this.state.users.filter((providersDisplayName: IUserView) =>
    {
      const searchFields = [
        providersDisplayName.displayName,
        providersDisplayName.userType,
        providersDisplayName.identityProviderName,
        providersDisplayName.securityProviderTypeName
      ];

      return searchFields.some(field =>
      {
        return field
          ? field.toString().toLowerCase().trim().includes(lowercaseSearchTerm)
          : false;
      });
    });
  }

  public render(): JSX.Element
  {

    const columns: GridColDef<IUserView>[] =
      [
        {
          field: Helper.nameOf<IUserView>("displayName"),
          headerName: this.labels.HubLabelName,
          flex: 1
        },
        {
          field: Helper.nameOf<IUserView>("identityProviderName"),
          headerName: this.labels.HubLabelIdentityprovider,
          flex: 1
        },
        {
          field: Helper.nameOf<IUserView>("securityProviderTypeName"),
          headerName: this.labels.HubLabelType,
          flex: 1
        },
        {
          field: Helper.nameOf<IUserView>("userType"),
          headerName: this.labels.HubLabeluserType,
          valueFormatter: ({ value }) => (value === 0 ? "User" : value === 1 ? "Application" : ""),
          flex: 1
        },
        {
          headerName: this.labels.HubLabelAction,
          minWidth: 120,
          field: "",
          flex: 1,
          filterable: false,
          sortable: false,
          renderCell: (params) => <>{this.handleUpdate(params.row.id)}</>
        }
      ];

    const actionButtons: IActionButton[] =
      [
        {
          label: this.labels.HubButtonAdd,
          className: "addIcon",
          icon: (
            <IbssSvgIcon>
              <AddIcon />
            </IbssSvgIcon>
          ),
          color: "primary",
          disabled: !this.userCanCreate,
          onClick: () => this.handleCreate()
        },
      ];
    const filteredUserList = this.filterUsers(this.state.filterText)

    return (
      <>
        <div className="page-height-exct-header">
          <div className="rightPanel-main-content">
            <div className="table-panel">
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <IbssPageHeader
                      title={this.labels.HubLabelUsers}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {
                      <div>
                        <div className='d-flex'>
                          <IbssFilter
                            searchTerm={this.state.filterText}
                            onSearchTermChange={(event) => this.setState({ filterText: event.target.value })}
                          />
                        </div>
                        <Box component="div" sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', my: 1, mr: 0 }}>
                          <IbssActionButton buttons={actionButtons} />
                        </Box>
                        <IbssDataGrid
                          loading={this.state.isLoading}
                          columns={columns}
                          rows={filteredUserList}
                          disableRowSelectionOnClick
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 25,
                                page: 0,
                              },
                            },
                          }}
                        />
                      </div>
                    }
                  </Grid>
                </Grid>
              </Box>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ListUsers;
interface IState
{
  isLoading: boolean;
  users: IUserView[];
  isCreateRight: boolean;
  isUpdateRight: boolean;
  filterText: string;
}

interface IProps extends RouteComponentProps { }

